import type {
  PurchaseContext,
  PurchaseExecutionInfo,
  UpgradeContext,
  UpgradeLicenseInfo,
} from '@/modules/licenses/types.ts'
import { apiClient } from '@/utils/axios.ts'

async function getUpgrade(cxt: UpgradeContext): Promise<UpgradeLicenseInfo> {
  const res = await apiClient.get(
    `creator/${cxt.creatorId}/upgrade/${cxt.planPrice}`,
  )

  return await res.data
}

async function postUpgrade(
  cxt: PurchaseContext,
): Promise<PurchaseExecutionInfo> {
  const params = {
    anticipatedPrice: cxt.anticipatedPrice,
  }
  const res = await apiClient.post(
    `creator/${cxt.creatorId}/upgrade/${cxt.planPrice}`,
    {},
    { params },
  )

  return res.data
}

export const upgradeService = {
  getUpgrade,
  postUpgrade,
}
